import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { HttpErrorResponse } from '@angular/common/http';

import { CLPUser, UserResponse } from '../../../../models/clpuser.model';
import { eFeatures, eServiceType, eUserRole } from '../../../../models/enum.model';
import { RoleFeaturePermissions } from '../../../../models/roleContainer.model';

import { LocalService } from '../../../../services/shared/local.service';
import { UtilityService } from '../../../../services/shared/utility.service';
import { AdminServiceStatusService } from '../../../../services/services-status.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { CLPFramework, ServiceStatusResponse } from '../../../../models/services-status.model';
import { NotificationService } from '../../../../services/notification.service';
import { SortDescriptor } from '@progress/kendo-data-query';
import { GridColumnsConfigurationService } from '../../../../services/gridColumnsConfiguration.service';

import { GridConfigurationService } from '../../../../services/shared/gridConfiguration.service';
import { process } from '@progress/kendo-data-query';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { GlobalService } from '../../../../services/global.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SimpleResponse } from '../../../../models/genericResponse.model';
declare var $: any;

@Component({
    selector: 'app-services-status',
    templateUrl: './services-status.component.html',
    styleUrls: ['./services-status.component.css'],
    providers: [GridConfigurationService]
})
/** services-status component*/
export class ServicesStatusComponent implements OnInit {
    /** services-status ctor */
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    mailingContactDataSource: MatTableDataSource<any>;
    mailingContactDataDisplayColumns: string[] = [];
    isExpProcessors: boolean = true;
    isExpTxtMsg: boolean = true;
    isExpVoicCall: boolean = true;
    isExpDrops: boolean = true;
    isExpCallRec: boolean = true;
    isExpRec: boolean = true;

    showSpinner: boolean = false;
    private encryptedUser: string = '';
    resetPro: string = '';
    user: CLPUser;
    userResponse: UserResponse;
    roleFeaturePermissions: RoleFeaturePermissions;
    serviceStatusResponse: ServiceStatusResponse;

    mailingContactData: any[] = [];
    initMailingContactData: any[] = [];
    processors: any;
    txtMsgs: any;
    voiceCalls: any;
    drop: any;
    voiceCallRec: any;
    recording: any;

    isExpdMailsQueue: boolean = false;
    pageSize: number = 10;
    columns = [
        { field: 'iD', title: 'Id', width: '60' },
        { field: 'user', title: 'User', width: '200' },
        { field: 'account', title: 'Account', width: '200' },
        { field: 'mailing', title: 'Mailing', width: '200' },
        { field: 'mailingID', title: 'Mailing ID', width: '200' },
        { field: 'result', title: 'Result', width: '200' },
        { field: 'cnt', title: 'Count', width: '110' },
    ];
    reorderColumnName: string = 'iD,account,user,mailing,mailingID,result,cnt';
    columnWidth: string = 'iD:60,account:200,user:200,mailing:200,mailingID:200,result:200,cnt:110';
    arrColumnWidth: any[] = ['iD:60,account:200,user:200,mailing:200,mailingID:200,result:200,cnt:110'];
    @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;
    gridHeight;
    mobileColumnNames: string[];
    isShowRestartedbutton: boolean = false;
    constructor(public _localService: LocalService,
        private _utilityService: UtilityService,
        private _servicesStatusService: AdminServiceStatusService,
        private _globalService: GlobalService,
        private _notifyService: NotificationService,
        private _gridColumnsConfigurationService: GridColumnsConfigurationService,
        public datepipe: DatePipe,
        private _router: Router,
        private ngZone: NgZone,
        public _gridCnfgService: GridConfigurationService
    ) {
        this.gridHeight = this._localService.getGridHeight('464px');
        this._localService.isMenu = true;
    }

    ngOnInit() {

        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        //Kendo grid load call stopped.
                        //this.getGridConfiguration();
                        this.getServiceStatus();
                    }
                    else
                        this._router.navigate(['/login']);
                });
            }
            else
                this._router.navigate(['/login']);
        });
    }

    //getGridConfiguration() {
    //    this._gridCnfgService.columns = this.columns;
    //    this._gridCnfgService.reorderColumnName = this.reorderColumnName;
    //    this._gridCnfgService.columnWidth = this.columnWidth;
    //    this._gridCnfgService.arrColumnWidth = this.arrColumnWidth;
    //    this._gridCnfgService.user = this.user;
    //    this._gridCnfgService.getGridColumnsConfiguration(this.user.cLPUserID, 'mailing_queue_grid').subscribe((value) => this._gridCnfgService.createGetGridColumnsConfiguration('mailing_queue_grid').subscribe((value) => { }));
    //}


    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.EngageServiceStatus, ":PP")
            .then(async (result: UserResponse) => {
                if (result) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    if (this.userResponse) {
                        if (this.userResponse?.user) {
                            this.user = this.userResponse.user;
                            this._gridCnfgService.user = this.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("serviceStatus.authenticateR", err.message, null, 'Features ' + eFeatures.None);
                this._utilityService.handleErrorResponse(err);
            });
    }


    //resetGridSetting() {
    //    this._gridCnfgService.deleteColumnsConfiguration(this.user.cLPUserID, 'mailing_queue_grid').subscribe((value) => this.getGridConfiguration());
    //}

    serviceStatusFilter(inputValue: string): void {
        this.mailingContactData = process(this.initMailingContactData, {
            filter: {
                logic: "or",
                filters: [
                    {
                        field: 'user',
                        operator: 'contains',
                        value: inputValue
                    },
                    {
                        field: 'account',
                        operator: 'contains',
                        value: inputValue
                    },
                    {
                        field: 'mailing',
                        operator: 'contains',
                        value: inputValue
                    }
                ],
            }
        }).data;
        this.dataBinding.skip = 0;
    }
    async getServiceStatus() {
        this.showSpinner = true;
        var currentTime = new Date();
        let converted_date = this.datepipe.transform(currentTime, 'yyyy-MM-dd hh:mm:ss');
        await this._servicesStatusService.getAdminServiceStatus(this.encryptedUser, converted_date, this.user?.cLPUserID, this.user?.cLPCompanyID)
            .then(async (result: ServiceStatusResponse) => {
                if (result) {
                    var result = UtilityService.clone(result);
                    this.serviceStatusResponse = UtilityService.clone(result);

                    if (!isNullOrUndefined(this._gridCnfgService)) {
                        this._gridCnfgService.iterateConfigGrid(this.serviceStatusResponse, "mailing_queue_grid");
                        this.mobileColumnNames = this._gridCnfgService.getResponsiveGridColums('mailing_queue_grid');
                    }

                    this.mailingContactData = this.serviceStatusResponse.mailingContactData && this.serviceStatusResponse.mailingContactData.length > 0 ? this.serviceStatusResponse.mailingContactData : [];
                    this.initMailingContactData = this.mailingContactData;
                    this.processors = result.processersStatuData.length > 0 ? result.processersStatuData[0] : null;
                    this.txtMsgs = {
                        manualInQueue: result.commonTableData.length > 0 ? result.commonTableData[0].manualInQueue_TxtMsg : null,
                        sFAInQueue: result.commonTableData.length > 0 ? result.commonTableData[0].sFAInQueue_TxtMsg : null,
                        wizardryInQueue: result.commonTableData.length > 0 ? result.commonTableData[0].wizardryInQueue_TxtMs : null,
                    }
                    this.voiceCalls = {
                        being: result.commonTableData.length > 0 ? result.commonTableData[0].beingHandled_VoiceCall : null,
                        manualInQueue: result.commonTableData.length > 0 ? result.commonTableData[0].manualInQueue_VoiceCall : null,
                        remindersInQueue: result.commonTableData.length > 0 ? result.commonTableData[0].remindersInQueue_VoiceCall : null,
                        sFAInQueue: result.commonTableData.length > 0 ? result.commonTableData[0].sFAInQueue_VoiceCall : null,
                    }
                    this.drop = {
                        being: result.commonTableData.length > 0 ? result.commonTableData[0].beingHandled_VoiceDrop : null,
                        inQueue: result.commonTableData.length > 0 ? result.commonTableData[0].inQueue_VoiceDrop : null,
                    }
                    this.voiceCallRec = {
                        being: result.commonTableData.length > 0 ? result.commonTableData[0].beingHandled_VoiceCallRecording : null,
                        inQueue: result.commonTableData.length > 0 ? result.commonTableData[0].inQueue_VoiceCallRecording : null,
                    }
                    this.recording = {
                        being: result.commonTableData.length > 0 ? result.commonTableData[0].beingHandled_VoiceRecording : null,
                        inQueue: result.commonTableData.length > 0 ? result.commonTableData[0].inQueue_VoiceRecording : null,
                    }
                    this.showSpinner = false;

                    this.setGrid(this.mailingContactData);
                }
                else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("services-status.getServiceStatus", err.message, null, 'converted_date ' + converted_date + "," + 'cLPCompanyID ' + this.user.cLPCompanyID + "," + "cLPUserID " + this.user.cLPUserID);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }



    resetProcessor(processor: string) {
        this.resetPro = processor;
        $('#processorResetModal').modal('show');
    }

    async confirmResetProcessor() {
        var serviceType = this.getServiceType();
        if (serviceType > -1) {
            this.showSpinner = true;
            await this._servicesStatusService.resetCLPFramework(this.encryptedUser, serviceType, this.user?.cLPUserID, this.user?.cLPCompanyID)
                .then(async (result: CLPFramework) => {
                    if (result) {
                        var result = UtilityService.clone(result);
                        this.showSpinner = false;
                        $('#processorResetModal').modal('hide');
                        if (result.errorMsg) {
                            this._notifyService.showError(result.errorMsg ? result.errorMsg : "Some error occured. Please contact administrator.", "", 3000);
                            return;
                        }
                        this.getServiceStatus();
                        this._notifyService.showSuccess(`The ${this.resetPro} processor was reset successfully.`, "", 3000);
                        this.resetPro = '';
                    }
                    else
                        this.showSpinner = false;
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("services-status.confirmResetProcessor", err.message, null, "serviceType " + serviceType + "," + 'cLPCompanyID ' + this.user.cLPCompanyID + "," + "cLPUserID " + this.user.cLPUserID);
                    this.showSpinner = false;
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    getServiceType() {
        var serviceType: number = -1;
        switch (this.resetPro) {
            case 'email':
                serviceType = eServiceType.EmailServ;
                break;
            case 'text':
                serviceType = eServiceType.TxtMsgServ;
                break;
            case 'voice':
                serviceType = eServiceType.VoiceServ;
                break;
            case 'Great Email':
                serviceType = eServiceType.EmailGMServ;
                break;
            default: serviceType = -1; break;
        }
        return serviceType;
    }

    setGrid(list) {
        this.mailingContactDataDisplayColumns = this.columns.map(c => c.field);
        this.mailingContactDataSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.mailingContactDataSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('mailing_queue_grid') ? this._localService.getPageSize('mailing_queue_grid') : 50;
            }
            if (this.sort) {
                this.mailingContactDataSource.sort = this.sort;
                const sortState: Sort = this._localService.getSortState('mailing_queue_grid');
                this.sort.active = sortState?.active;
                this.sort.direction = sortState?.direction;
                this.sort.sortChange.emit(sortState);
            }
        }, 500)

    }

    getSerialNumber(index: number): number {
        return index + 1 + (this.paginator?.pageIndex || 0) * (this.paginator?.pageSize || 5);
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    ngOnDestroy() {
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }

    async reStartCSC() {
        this.showSpinner = true;
        await this._servicesStatusService.reStartCSC(this.encryptedUser, this.user?.cLPUserID, this.user?.cLPCompanyID)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    this.isShowRestartedbutton = true;
                    this.showSpinner = false;
                }
                else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("services-status.reStartCSC", err.message, null,);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }


    async pauseCSC() {
        this.showSpinner = true;
        await this._servicesStatusService.pauseCSC(this.encryptedUser, this.user?.cLPUserID, this.user?.cLPCompanyID)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    this.showSpinner = false;
                }
                else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("services-status.pauseCSC", err.message, null, );
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });

    }


}
